import { DateTime } from "luxon";

export const getDateRange = (rawDate?: number) => {
  if (!rawDate) return [];
  const rawMsDate = new Date(rawDate).getTime();
  return [
    {
      startDate: DateTime.fromMillis(rawMsDate - 100000),
      endDate: DateTime.fromMillis(rawMsDate),
      tzName: DateTime.fromMillis(rawMsDate).zoneName ?? undefined,
    },
  ];
};
